import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function CTAFinalSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-carbon border-t border-carbon-lighter relative overflow-hidden" data-id="element-65">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-66"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-67">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-68">
          Deja de limpiar por horas. <br className="hidden md:block" data-id="element-69" />
          <span className="text-gold" data-id="element-70">Empieza a cobrar por contratos.</span>
        </h2>
        <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-71">
          Agenda una llamada estratégica gratuita para analizar tu negocio de
          limpieza y mostrarte cómo implementar el Sistema A.C.E.™ en tu
          ciudad.
        </p>

        <div className="flex flex-col items-center w-full" data-id="element-72">
          <CTAButton className="w-full sm:w-auto px-10 py-5 text-xl mb-4" data-id="element-73">
            QUIERO CONTRATOS DE LIMPIEZA PREMIUM
          </CTAButton>

          <div className="flex flex-col items-center mt-4" data-id="element-74">
            <span className="text-gray-400 text-sm mb-1" data-id="element-75">
              ¿Prefieres agendar directamente?
            </span>
            <a href="https://calendar.app.google/gDsqAVqmwUYmaZHe9" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-light underline text-sm md:text-base font-medium transition-colors" data-id="element-76">
              Haz tu cita en Google Calendar aquí
            </a>
          </div>
        </div>

        <p className="mt-8 text-sm text-gray-500" data-id="element-77">
          Espacios limitados. Solo para dueños de negocios de limpieza
          comprometidos con crecer.
        </p>
      </div>
    </section>;
}